"use client";

import type { FC, Ref } from "react";
import { Text } from "@huub-web/ui/components/Text";
import { Markdown } from "@huub-web/ui/components/Markdown";

export interface MarkdownTemplateProps {
  value: string;
  variant?: "default" | "description";
}

export const MarkdownTemplate: FC<
  MarkdownTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ value, variant = "default", ref }) => (
  <Text
    ref={ref}
    as="div"
    variant={variant === "description" ? "bodyS" : undefined}
    color={variant === "description" ? "onSecondary" : undefined}
  >
    <Markdown content={value} />
  </Text>
);
